import { ubicationTypeEnum } from '../../utils/dataStatus';

const mapPosLine = (pL) => ({
  cantidad: pL.cantidad,
  idPosicion: pL?.idPosicion,
  numeroPosicion: pL?.numeroPosicion,
  numeroLinea: pL?.numeroLinea,
  descripcionPosicionSap: pL?.descripcionPosicionSap,
  descripcionPosicionYClick: pL?.descripcionPosicionYClick,
  idLinea: pL?.idLinea,
  descripcionLineaSap: pL?.descripcionLineaSap,
  descripcionLineaYClick: pL?.descripcionLineaYClick,
  unidadMedida: pL?.unidadMedida,
  onCall: pL?.onCall,
  mensualizada: pL?.mensualizada
});

const mapWell = (well) => ({
  idPozo: well?.well?.id,
  pozoNombre: well?.well?.nombre,
  idEquipo: well?.team?.id,
  tipoImputacionEnum: well?.imputationType?.id,
  idObjetoImputacion: well?.imputationObject?.id,
  idEventoPozo: well?.event?.eventoPozoId
});

const getPozos = (location) => {
  if (location?.isOyM) {
    return null;
  }

  return location?.imputationObject?.wells?.map(mapWell);
};

/* eslint-disable import/prefer-default-export */
export const monthlyTemplateUbicationsAdapter = (locations) =>
  locations?.map((location) => ({
    tipoUbicacionEnum: location?.tipoUbicacionEnum,
    idLocacion:
      (location?.tipoUbicacionEnum || location?.ubication?.ubicationType?.id) !==
      ubicationTypeEnum.locacion
        ? null
        : location?.ubication?.ubication?.id || location.idLocacion,
    ubicacionNombre: location?.nombre || location?.ubication?.ubication?.nombre,
    idUnidadNegocio: location?.isOyM ? null : location?.ubication?.uunn?.id,
    idOperacion: location?.isOyM ? location?.ubication?.uunn?.id : null,
    codigoSapOperacion: location?.ubication?.uunn?.codigoSAP,
    descripcionOperacion: location?.ubication?.uunn?.label,
    tipoEvento: location?.isOyM
      ? location?.ubication?.ubicationType?.tipoNegocio?.evento?.sigla
      : location?.ubication?.event?.sigla,
    eventoNombre: location?.isOyM
      ? location?.ubication?.ubicationType?.tipoNegocio?.evento?.sigla
      : location?.ubication?.event?.nombre || location?.ubication?.typeEvent?.nombreLargo,
    eventoSigla: location?.isOyM
      ? location?.ubication?.ubicationType?.tipoNegocio?.evento?.sigla
      : location?.ubication?.event?.sigla || location?.ubication?.typeEvent?.sigla,
    idEvento: location?.isOyM
      ? location?.ubication?.ubicationType?.tipoNegocio?.evento?.id ||
        location?.ubication?.ubicationType?.tipoNegocio?.eventoId
      : location?.ubication?.event?.id || location?.ubication?.typeEvent?.id,
    nombreEquipo: location?.ubication?.team?.nombre,
    ubicacionTecnica: location?.isOyM
      ? {
          clasificacionNombre: location?.ubication?.classification?.nombre,
          idClasificacion: location?.ubication?.classification?.id,
          // Lo que ya estaba
          codigoSapInstalacion: location?.ubication?.installation?.codigoSAP,
          codigoSapUbicacion: location?.ubication?.ubication?.codigoSAP,
          descripcionInstalacion: location?.ubication?.installation?.label,
          descripcionUbicacion: location?.ubication?.ubication?.label,
          equipo: location?.ubication?.team?.nombre,
          idInstalacion: location?.ubication?.installation?.id,
          idObjetoImputacion: location?.imputationObject?.wells[0]?.imputationObject?.id,
          idUbicacionTecnica: location?.ubication?.ubication?.id,
          tipoImputacionEnum: location?.imputationObject?.wells[0]?.imputationType?.id
        }
      : null,
    pozos: getPozos(location),
    plantillaParteTrabajoLineaMsds: location?.posLines?.map(mapPosLine)
  }));

export const getTemplateAdapter = (ubications) =>
  ubications?.map((ubication) => ({
    id: ubication?.idPlantillaParteTrabajoUbicacion,
    isOyM:
      ubication?.tipoUbicacionEnum !== ubicationTypeEnum.pozo &&
      ubication?.tipoUbicacionEnum !== ubicationTypeEnum.locacion,
    nombre: ubication?.ubicacionNombre,
    idOperacion: ubication?.idOperacion,
    descripcionOperacion: ubication?.descripcionOperacion,
    codigoSapOperacion: ubication?.codigoSapOperacion,
    idUnidadNegocio: ubication?.idUnidadNegocio,
    tienePosicionLinea: !!ubication?.plantillaParteTrabajoLineasMsds?.length,
    posLines: ubication?.plantillaParteTrabajoLineasMsds?.map((pL) => ({
      ...pL,
      positionName: `${pL?.numeroPosicion} - ${pL?.descripcionPosicionSap}`,
      lineName: `${pL?.numeroLinea} - ${pL?.descripcionLineaSap}`,
      cantidad: pL?.cantidad
    })),
    idEvento: ubication?.idEvento,
    tipoEvento: ubication?.eventoSigla,
    eventoNombre: ubication?.eventoNombre,
    idLocacion: ubication?.idLocacion,
    ubicacionTecnica: ubication?.ubicacionTecnica,
    pozos: ubication?.pozos,
    tipoUbicacionEnum: ubication?.tipoUbicacionEnum,
    eliminarUbicacion: false
  }));

export const putUbicationTemplateAdapter = (ubications) =>
  ubications.map((ubication) => ({
    idPlantillaParteTrabajoUbicacion: ubication.isNewUbication ? null : ubication?.id,
    eliminarUbicacion: ubication?.eliminarUbicacion,
    tipoUbicacionEnum: ubication?.tipoUbicacionEnum,
    ubicacionNombre: ubication?.nombre,
    idLocacion: ubication?.idLocacion,
    idUnidadNegocio: ubication?.idUnidadNegocio,
    idOperacion: ubication?.idOperacion,
    codigoSapOperacion: ubication?.codigoSapOperacion,
    descripcionOperacion: ubication?.descripcionOperacion,
    idEvento: ubication?.idEvento,
    eventoNombre: ubication?.eventoNombre,
    eventoSigla: ubication?.tipoEvento,
    ubicacionTecnica: ubication?.ubicacionTecnica,
    pozos: ubication?.pozos,
    plantillaParteTrabajoLineaMsds: ubication?.posLines
  }));
